export enum TIPO_WMS {
  entrega = 'REC',
  coleta = 'EXP',
}
